import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled, { css } from 'styled-components';

const Wrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.5rem;
  width: 3.5rem;
  border-radius: 100%;
  position: fixed;
  bottom: 0;
  right: 0;
  margin: 0 1rem 1rem 0;
  z-index: 50;
  cursor: pointer;
  background-color: rgb(17, 24, 39);
  opacity: 50%;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;

  &:focus {
    opacity: 100%;
  }

  ${({ show }) =>
    show
      ? css`
          transform: translateY(0);
        `
      : css`
          background-color: rgba(17, 24, 39, 0);
          transform: translateY(100%);
        `}

  & > svg {
    width: 2rem;
    height: 2rem;
    color: white;
  }
`;

function scrollToTop() {
  document.documentElement.scrollIntoView({
    behavior: 'auto',
  });
}

function ScrollToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setShow(
        document.body.scrollTop > 100 ||
          document.documentElement.scrollTop > 100
      );
    });
  }, []);

  return ReactDOM.createPortal(
    <Wrapper onClick={scrollToTop} show={show}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 15l7-7 7 7"
        />
      </svg>
    </Wrapper>,
    document.body
  );
}

export default ScrollToTop;
